import { filter } from 'ramda';
import { getCharacterLimits, makeCharacterLimitMap } from './characterLimitMap';
import findCharacterLimit from './findCharacterLimit';

/* CustomLimit is
    { 
        viewName?: String,
        ctrlid?: String,
        xpath: String,
        maxLength: Number,
        moveNext: Boolean,
        dsName: String,
    }
*/

const characterLimitSource = (template, dataSources) => {
    let customLimits = [];

    // { (viewName: String): CharacterLimitMap }
    let limitMaps = {};

    // { (viewName: String): { (ctrlid: String): CharacterLimit } }
    let limitCache = {};

    // void -> void
    const resetCaches = () => {
        limitMaps = {};
        limitCache = {};
    };

    const limitCacheForView = (viewName) => {
        if (!(viewName in limitCache)) {
            limitCache[viewName] = {};
        }

        return limitCache[viewName];
    };

    // CustomLimit -> void
    const addCustomLimit = (customLimit) => {
        customLimits.push(customLimit);

        resetCaches();
    };

    // String -> CharacterLimitMap
    const getLimitMapInner = (view) => makeCharacterLimitMap([
        ...filter(
            ({ viewName }) => !viewName || viewName === view,
            customLimits,
        ),
        ...getCharacterLimits(template.getEditableComponents(view)),
    ]);

    // String -> CharacterLimitMap
    const getLimitMap = (viewName) => {
        if (!(viewName in limitMaps)) {
            limitMaps[viewName] = getLimitMapInner(viewName);
        }

        return limitMaps[viewName];
    };

    // (String, DOMNode, String) -> CharacterLimit
    const getCharacterLimit = (viewName, node, ctrlId) => {
        const cache = limitCacheForView(viewName);

        if (!(ctrlId in cache)) {
            cache[ctrlId] = findCharacterLimit(getLimitMap(viewName), dataSources, node, ctrlId);
        }
        
        return cache[ctrlId];
    };

    return {
        addCustomLimit,
        getCharacterLimit,
    };
};


export default characterLimitSource;